const initialLuxeTopNavState = [];

function luxeTopNavReducer(state = initialLuxeTopNavState, action) {
  switch (action.type) {
    case 'LUXE_TOP_NAV_API_SUCCESS':
      return [...action.data];
    default:
      return state;
  }
}

export default luxeTopNavReducer;
